import _ from 'lodash';
import { sqImportDatafileStore } from '@/core/core.stores';
import { DISPLAY_MODE } from '@/main/app.constants';
import { setActiveTool } from '@/toolSelection/investigate.actions';
import { TREND_TOOLS } from '@/toolSelection/investigate.constants';
import { createRehydratePayload } from '@/tools/importDatafile/importDatafile.utilities';
import { getAllItems } from '@/trend/trendDataHelper.utilities';
import { fetchItemAndDependents } from '@/trendData/trend.actions';
import { sqTimezones } from '@/utilities/datetime.constants';
import { tabsetChangeTab } from '@/worksheet/worksheet.actions';
import { sqDatafilesApi } from '@seeqdev/api/endpoint/DatafilesApi';
import { sqItemsApi } from '@seeqdev/api/endpoint/ItemsApi';

/**
 * Loads the saved CSV settings and opens the Import Datafile form.
 * Search calls this directly; loadToolForEdit calls it for signals and conditions from a datafile.
 */
export function loadDatafile(id: string, duplicate = false) {
  return sqDatafilesApi.getDatafile({ id }).then(({ data }) => {
    const payload = createRehydratePayload(data, sqTimezones.timezones);
    sqImportDatafileStore.actions.rehydrateForEdit({
      ...payload,
      uploadFilename: '',
      id: duplicate ? undefined : data.id,
      name: duplicate ? undefined : data.name,
    });
    tabsetChangeTab('sidebar', 'investigate');
    setActiveTool(TREND_TOOLS.IMPORTDATAFILE, DISPLAY_MODE.EDIT);
  });
}

/** Refreshes displayed items hosted by a changed datafile and their dependents. */
export function refreshDatafileItems(id: string) {
  sqDatafilesApi.getItemsHostedByDatafile({ id }).then(({ data: { items } }) => {
    const trendItemsIds = _.map(getAllItems({}), 'id');
    const datafileItemIds = _.map(items, 'id');
    _.chain(trendItemsIds)
      .map((id) =>
        _.includes(datafileItemIds, id)
          ? Promise.resolve(id)
          : sqItemsApi.getFormulaDependencies({ id }).then(({ data: { dependencies } }) =>
              _.chain(dependencies)
                .map('id')
                .intersection(datafileItemIds)
                .thru((intersections) => (intersections.length ? id : null))
                .value(),
            ),
      )
      .thru((promises) => Promise.all(promises))
      .value()
      .then((ids) =>
        _.chain(ids)
          .compact()
          .uniq()
          .forEach((id) => fetchItemAndDependents(id))
          .value(),
      );
  });
}
